import { render, staticRenderFns } from "./NBCard.vue?vue&type=template&id=5e8f082c&scoped=true"
import script from "./NBCard.vue?vue&type=script&lang=js"
export * from "./NBCard.vue?vue&type=script&lang=js"
import style0 from "./NBCard.vue?vue&type=style&index=0&id=5e8f082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f082c",
  null
  
)

export default component.exports